import Icon from '../components/Icon.vue'

Icon.register({
  'glass-whiskey': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 32c19.5 0 34.4 17.2 31.7 36.5l-55.6 356.5c-4.5 31.5-31.6 54.9-63.4 54.9h-273c-31.9 0-58.9-23.4-63.4-54.9l-56-356.5c-2.7-19.3 12.2-36.5 31.7-36.5h448zM442.6 96h-373.2l30.2 192h313z'
      }
    ]
  }
})
